export enum UserRoles {
    Admin = 1,
    ProspectManager,
    ProjectCoordinator,
    HRAdmin,
    HR,
    AccountingAdmin,
    Accounting,
    Landman,
    Cartographer,
    ContractorSuper,
    ClientUser
}

export default class UserRole {
    id: number;
    role: string;
}



// WEBPACK FOOTER //
// ./src/models/UserRole.ts